import {
	useAcademyEvents,
	useAlerts,
	useEvents,
	useTimezones,
	useUploadFileInMemory
} from 'hooks';
import AcademyEventForm from './AcademyEventForm';
import { ImageUploader, Subheader } from 'components';
import { Button, Container } from '@mui/material';
import useAcademies from 'hooks/useAcadamies';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Check } from '@mui/icons-material';
import { validateAcademyEvent } from 'validations/academyEvent';

const AcademyEventEdit = ({}) => {
	const { academy_id, id } = useParams();

	const { findTimezones, timezones } = useTimezones();

	const {
		academyEvent,
		isLoading,
		handleChange,
		findAcademyEvent,
		uploadFile,
		deleteFile,
		updateAcademyEvent
	} = useAcademyEvents({ id: id });
	const { academy, findAcademy } = useAcademies({});

	const { showAlertError, showAlertSuccess } = useAlerts();
	const navigate = useNavigate();

	const handleUpload = async (file, type) => {
		await uploadFile(file, type);
		findAcademyEvent(id);
	};

	const handleDelete = async (type) => {
		await deleteFile(type);
		findAcademyEvent(id);
	};

	const handleSaveClick = async () => {
		if (!academyEvent.academy_id) {
			console.error('Academy ID is required');
			showAlertError('Please select an academy for the event.');
			return;
		}

		if (!academy.timezone) {
			handleChange({
				target: {
					name: 'timezone',
					value: 'Asia/Dubai'
				}
			});
		}

		const validation = validateAcademyEvent(academyEvent);

		if (!validation.isValid) {
			validation.messages.forEach((message) => showAlertError(message));
			return;
		}
		try {
			await updateAcademyEvent(academyEvent);
			showAlertSuccess('Academy Event has been updated');
			navigate(`/academy/events/${academyEvent.id}`);
		} catch (error) {
			console.error('Error creating academy event:', error);
			showAlertError('Failed to create academy event.');
		}
	};

	useEffect(() => {
		if (id) {
			findAcademyEvent(id);
		}
	}, [id]);

	useEffect(() => {
		if (academy_id) {
			findAcademy(academy_id);
		}
	}, [academy_id]);

	useEffect(() => {
		findTimezones();
	}, []);

	return (
		<>
			<Subheader
				title={isLoading ? 'Loading...' : `Edit ${academyEvent.name}`}
				buttons={[
					<Button
						color="primary"
						variant="contained"
						startIcon={<Check />}
						onClick={handleSaveClick}
					>
						Update Academy Event
					</Button>
				]}
			/>
			<Container>
				<center>
					<ImageUploader
						label="Upload event image"
						imageUrl={academyEvent.image_url}
						handleUpload={(file) => handleUpload(file, 'image_url')}
						handleDelete={() => handleDelete('image_url')}
					/>
				</center>
				{academyEvent && !isLoading && (
					<AcademyEventForm
						event={academyEvent}
						handleChange={handleChange}
						academies={[academy]}
						timezones={timezones}
					/>
				)}
			</Container>
		</>
	);
};

export default AcademyEventEdit;
